import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { distance as formatDistance } from 'src/domains/sportsbook/utils/format';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import {
    CardHeaderRaceName,
    CardHeaderRaceMeta,
    CardHeaderStreamIco,
    CardHeaderWrapper,
    CardHeaderData,
    CardHeaderStreamUnifiedIco,
} from 'src/domains/sportsbook/webview/components/racesSlider/shared/cardHeader/CardHeader.style';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export interface CardHeaderPropsType {
    race: EventModel;
    routingData: RacecardRaceRouteType;
}

export const CardHeader = observer('CardHeader', (props: CardHeaderPropsType) => {
    const { race, routingData } = props;
    const common = useCommon();
    const {
        componentVariants: { raceCardVariant },
        hasEventLiveStreaming,
    } = ConfigComponents.get(common).unifiedComponentConfig;
    const streamingState = StreamingState.get(common);
    const distance = formatDistance(race.feedDistance);

    const [raceHourPart, ...racePlaceParts] = race.name.split(' ');
    const racePlace = racePlaceParts.join(' ');
    const raceHour = raceHourPart ?? '';

    const hasStream = hasEventLiveStreaming && streamingState.hasStream(race.id2.toOldId());
    const CardHeaderStreamIcoComponent =
        raceCardVariant === DefaultComponentVariantType.TERTIARY ? CardHeaderStreamUnifiedIco : CardHeaderStreamIco;

    return (
        <CardHeaderWrapper
            dataTest='event'
            to={routingData}
            key='race-box__header-link'
            variant={raceCardVariant}
        >
            {hasStream && <CardHeaderStreamIcoComponent />}

            <CardHeaderData>
                {racePlace !== '' && (
                    <CardHeaderRaceName data-test='race-card-header-name'>{racePlace}</CardHeaderRaceName>
                )}

                {raceHour !== '' && <CardHeaderRaceMeta>{raceHour}</CardHeaderRaceMeta>}

                {distance !== '' && <CardHeaderRaceMeta>{distance}</CardHeaderRaceMeta>}
            </CardHeaderData>
        </CardHeaderWrapper>
    );
});
